(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-article-toc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var blocks = document.querySelectorAll('[data-article-toc-block]');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var toc = block.querySelector('.article-toc__list');
      if (!toc) return;

      var section = block.closest('.section');
      if (!section) {
        collapseToc(block);
        return;
      }

      var headings = findArticleHeadings(section, block);
      if (!headings.length) {
        collapseToc(block);
        return;
      }

      block.hidden = false;
      block.dataset.tocState = 'ready';

      buildToc(block, toc, headings);
    });

    function findArticleHeadings(section, block) {
      var roots = section.querySelectorAll('.blog-post-content, .rte, rte-formatter');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].contains(block)) continue;
        var headings = roots[i].querySelectorAll('h2');
        if (headings.length) return Array.prototype.slice.call(headings);
      }

      return Array.prototype.slice.call(section.querySelectorAll('h2')).filter(function (heading) {
        return !block.contains(heading);
      });
    }

    function collapseToc(block) {
      block.dataset.tocState = 'empty';
      block.hidden = true;
    }

    function buildToc(block, toc, headings) {
      var slugUsed = {};
      var frag = document.createDocumentFragment();

      headings.forEach(function (h) {
        if (!h.id) {
          var base = slugify(h.textContent) || 'section';
          var slug = base;
          var n = 2;
          while (slugUsed[slug] || document.getElementById(slug)) {
            slug = base + '-' + n++;
          }
          h.id = slug;
        }
        slugUsed[h.id] = true;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        frag.appendChild(li);
      });
      toc.appendChild(frag);

      var bar = block.querySelector('.article-toc__progress-bar');
      var links = toc.querySelectorAll('a');

      function getHeaderHeight() {
        var header = document.getElementById('header-component');
        if (header) {
          var rect = header.getBoundingClientRect();
          if (rect.height > 0) return Math.round(rect.height);
        }

        var styles = window.getComputedStyle(document.body);
        var headerHeight = parseFloat(styles.getPropertyValue('--header-height'));
        return Number.isNaN(headerHeight) ? 70 : Math.round(headerHeight);
      }

      function getHeaderBottom() {
        var header = document.getElementById('header-component');
        if (header) {
          var rect = header.getBoundingClientRect();
          if (rect.bottom > 0) return Math.round(rect.bottom);
        }

        return getHeaderHeight();
      }

      function updateAnchorOffset() {
        document.documentElement.style.setProperty('--article-anchor-offset', getHeaderHeight() + 'px');
      }

      function getScrollOffset() {
        return getHeaderBottom() + 16;
      }

      function onScroll() {
        var scrollY = window.scrollY;
        var docH = document.documentElement.scrollHeight - window.innerHeight;
        if (bar) {
          if (docH <= 0) {
            bar.style.width = '0%';
          } else {
            bar.style.width = Math.min(100, Math.round((scrollY / docH) * 100)) + '%';
          }
        }

        var active = null;
        var offset = getScrollOffset();
        for (var i = headings.length - 1; i >= 0; i--) {
          if (headings[i].getBoundingClientRect().top <= offset) {
            active = i;
            break;
          }
        }
        links.forEach(function (link, index) {
          link.classList.toggle('is-active', index === active);
        });
      }

      updateAnchorOffset();
      window.addEventListener('resize', updateAnchorOffset, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      if (window.location.hash) {
        var hash = window.location.hash.slice(1);
        try {
          hash = decodeURIComponent(hash);
        } catch (e) {
          // Keep the raw hash if it is not valid URI encoding.
        }

        var target = document.getElementById(hash);
        if (target) {
          requestAnimationFrame(function () {
            target.scrollIntoView({ block: 'start' });
          });
        }
      }
    }

    function slugify(text) {
      return text
        .toLowerCase()
        .replace(/[\u2018\u2019]/g, "'")
        .replace(/[\u201c\u201d]/g, '"')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-follow-on-shop"] && !Shopify.designMode) return;
  try {
    (function () {
    function recolor(sr) {
      if (!sr) return;
      var labels = sr.querySelectorAll('.text-black');
      for (var i = 0; i < labels.length; i++) {
        var lb = labels[i];
        lb.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
        lb.style.setProperty('color', '#fff', 'important');
      }
    }
    function fixOne(el) {
      if (!el || !el.shadowRoot) return false;
      recolor(el.shadowRoot);
      if (!el.getAttribute('data-bt-observed') && window.MutationObserver) {
        el.setAttribute('data-bt-observed', '1');
        var mo = new MutationObserver(function () { recolor(el.shadowRoot); });
        mo.observe(el.shadowRoot, { childList: true, subtree: true });
      }
      return true;
    }
    function sweep() {
      var list = document.querySelectorAll('shop-follow-button');
      for (var i = 0; i < list.length; i++) { fixOne(list[i]); }
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      sweep();
      if (tries > 30) { clearInterval(timer); }
    }, 500);
    sweep();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-forms-basin"] && !Shopify.designMode) return;
  try {
    (function () {
    function emailValid(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }
    function phoneValid(v) {
      return /^\+?1?\s*[-.\s(]*\d{3}[-.\s)]*\d{3}[-.\s]*\d{4}$/.test(v);
    }
    // Normalize to E.164 so Basin (and downstream Zendesk/Klaviyo) get a clean number.
    function normalizePhone(raw) {
      var digits = (raw || '').replace(/\D/g, '');
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
      if (digits.length > 0 && raw.charAt(0) === '+') return '+' + digits;
      return raw;
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    // Local "today" as YYYY-MM-DD. Computed client-side on purpose: the storefront
    // HTML is CDN-cached, so a Liquid-rendered date could be stale and wrongly block
    // valid recent purchase dates. The visitor's browser clock is always current.
    function todayISO() {
      var d = new Date();
      return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    // Validate a native date-input value. The browser hands back YYYY-MM-DD, but the
    // year segment accepts 5+ digits -- that is how "20026-06-16" reached the warranty
    // automation and crashed it. Returns an error message, or '' when acceptable.
    function dateError(input, value) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
      if (!m) return 'Please enter a valid date using the date picker.';
      var y = +m[1], mo = +m[2], da = +m[3];
      var d = new Date(y, mo - 1, da);
      if (d.getFullYear() !== y || d.getMonth() !== mo - 1 || d.getDate() !== da) {
        return 'Please enter a valid date using the date picker.';
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (d.getTime() > today.getTime()) return 'The date of purchase cannot be in the future.';
      var minAttr = input.getAttribute('min');
      var mm = minAttr ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(minAttr) : null;
      if (mm) {
        var minD = new Date(+mm[1], +mm[2] - 1, +mm[3]);
        if (d.getTime() < minD.getTime()) return 'Please enter a date of purchase from ' + (+mm[1]) + ' or later.';
      }
      return '';
    }

    function fieldErrorEl(input) {
      return document.getElementById(input.id + '-error');
    }

    // Set both the inline error text and the data-error-msg (used by the error
    // summary) so a field can carry a context-specific message, e.g. future date.
    function setErrorMsg(input, msg) {
      input.setAttribute('data-error-msg', msg);
      var el = fieldErrorEl(input);
      if (el) el.textContent = msg;
    }

    function validateInput(input) {
      var valid = true;
      if (input.type === 'checkbox') {
        if (input.hasAttribute('required') && !input.checked) valid = false;
      } else {
        var value = (input.value || '').trim();
        if (input.type === 'date') {
          // All date handling lives here (including required-empty) so the message is
          // always recomputed -- a stale "future date" error never lingers after the
          // field is cleared or corrected.
          var dDefault = input.getAttribute('data-error-default') || input.getAttribute('data-error-msg') || '';
          var dMsg = dDefault;
          if (input.hasAttribute('required') && !value) {
            valid = false;
          } else if (value) {
            var de = dateError(input, value);
            if (de) { valid = false; dMsg = de; }
          }
          setErrorMsg(input, dMsg);
        } else if (input.hasAttribute('required') && !value) {
          valid = false;
        } else if (input.type === 'email' && value && !emailValid(value)) {
          valid = false;
        } else if (input.type === 'tel' && value && !phoneValid(value)) {
          valid = false;
        }
      }
      var err = fieldErrorEl(input);
      if (!valid) {
        input.setAttribute('aria-invalid', 'true');
        if (err) err.setAttribute('aria-hidden', 'false');
      } else {
        input.removeAttribute('aria-invalid');
        if (err) err.setAttribute('aria-hidden', 'true');
      }
      return valid;
    }

    function initForm(form) {
      var submitBtn = form.querySelector('[data-submit]');
      var summary = form.querySelector('[data-error-summary]');
      var summaryList = form.querySelector('[data-error-list]');
      var success = form.querySelector('[data-success]');
      var errorEmailEl = form.querySelector('[data-error-email]');
      var errorEmail = errorEmailEl ? errorEmailEl.textContent.trim() : '';

      // Conditional fields: reveal + require only when their controller matches.
      var conditionals = [].slice.call(form.querySelectorAll('[data-show-when]'));
      conditionals.forEach(function (wrap) {
        var controllerName = wrap.getAttribute('data-show-when');
        var showValue = wrap.getAttribute('data-show-value');
        var field = wrap.querySelector('input, select, textarea');
        var controller = form.querySelector('[name="' + controllerName + '"]');
        if (!controller || !field) return;
        function sync() {
          var match = controller.value === showValue;
          wrap.classList.toggle('is-hidden', !match);
          if (match) {
            field.setAttribute('required', '');
            field.setAttribute('aria-required', 'true');
          } else {
            field.removeAttribute('required');
            field.removeAttribute('aria-required');
            field.value = '';
            field.removeAttribute('aria-invalid');
            var err = fieldErrorEl(field);
            if (err) err.setAttribute('aria-hidden', 'true');
          }
        }
        controller.addEventListener('change', sync);
        sync();
      });

      var inputs = [].slice.call(form.querySelectorAll('input, textarea, select')).filter(function (el) {
        return el.name && el.name !== '_gotcha' && el.type !== 'hidden';
      });

      function clearErrors() {
        inputs.forEach(function (input) {
          input.removeAttribute('aria-invalid');
          var err = fieldErrorEl(input);
          if (err) err.setAttribute('aria-hidden', 'true');
        });
        if (summary) summary.classList.remove('is-visible');
        if (summaryList) summaryList.innerHTML = '';
      }

      inputs.forEach(function (input) {
        var evt = (input.type === 'checkbox' || input.type === 'radio' || input.tagName === 'SELECT') ? 'change' : 'blur';
        input.addEventListener(evt, function () { validateInput(input); });
        input.addEventListener('input', function () {
          if (input.getAttribute('aria-invalid') === 'true') validateInput(input);
        });
      });

      // Date fields: cap the selectable range at today (client-local, so a CDN-cached
      // page can't ship a stale ceiling). Typing stays the native path -- we never
      // auto-open the picker on a field click, because showPicker() moves keyboard focus
      // into the calendar grid and swallows the first keystrokes. Instead the picker is
      // opened from a separate, clearly visible calendar button (below), so a visitor can
      // either type the date or pick it without the two stealing focus from each other.
      var dateInputs = [].slice.call(form.querySelectorAll('input[type="date"]'));
      dateInputs.forEach(function (di) {
        di.setAttribute('data-error-default', di.getAttribute('data-error-msg') || '');
        di.max = todayISO();
        var wrap = di.closest('[data-date-wrap]');
        var toggle = wrap ? wrap.querySelector('[data-date-toggle]') : null;
        if (toggle && typeof di.showPicker === 'function') {
          // Progressive enhancement: reveal our button (and hide the tiny native icon)
          // only when the browser can open the picker on demand. Otherwise the native
          // icon stays as the fallback.
          wrap.classList.add('has-custom-picker');
          toggle.addEventListener('click', function () {
            try { di.showPicker(); } catch (e) { di.focus(); }
          });
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearErrors();

        var invalid = inputs.filter(function (input) { return !validateInput(input); });
        if (invalid.length > 0 && summary && summaryList) {
          invalid.forEach(function (input) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + input.id;
            a.textContent = input.getAttribute('data-error-msg') || 'This field is required.';
            a.addEventListener('click', function (ev) {
              ev.preventDefault();
              input.focus();
            });
            li.appendChild(a);
            summaryList.appendChild(li);
          });
          summary.classList.add('is-visible');
          requestAnimationFrame(function () {
            var heading = summary.querySelector('p[tabindex]');
            if (heading) {
              heading.focus();
              heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
          return;
        }

        // Clean the phone in place so the submitted payload carries E.164.
        var phoneInput = form.querySelector('input[type="tel"]');
        if (phoneInput) phoneInput.value = normalizePhone(phoneInput.value);

        try {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending...';
        }

        var formData = new FormData(form);

        fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Submission failed');
            var firstEl = form.querySelector('input[name="first_name"]');
            var lastEl = form.querySelector('input[name="last_name"]');
            var emailEl = form.querySelector('input[name="email"]');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'generate_lead',
              form_id: form.id,
              form_name: form.getAttribute('data-form-name') || form.getAttribute('data-form-key') || '',
              user_data: {
                email_address: emailEl ? emailEl.value.trim().toLowerCase() : '',
                phone_number: phoneInput ? phoneInput.value : '',
                address: {
                  first_name: firstEl ? firstEl.value.trim() : '',
                  last_name: lastEl ? lastEl.value.trim() : ''
                }
              }
            });
            form.reset();
            if (success) {
              success.classList.add('is-visible');
              requestAnimationFrame(function () {
                var heading = success.querySelector('p[tabindex]');
                if (heading) {
                  heading.focus();
                  heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              });
            }
          })
          .catch(function () {
            if (summary && summaryList) {
              var contact = errorEmail
                ? ' Please try again or contact us at ' + errorEmail + '.'
                : ' Please try again.';
              summaryList.innerHTML = '<li>Something went wrong.' + contact + '</li>';
              summary.classList.add('is-visible');
              requestAnimationFrame(function () {
                var heading = summary.querySelector('p[tabindex]');
                if (heading) heading.focus();
              });
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-default-label') || 'Send Message';
            }
          });
        } catch (syncErr) {
          // fetch() (or FormData) can throw synchronously -- e.g. a CSP connect-src
          // block or a bad action URL -- before the promise chain exists, so the
          // .catch/.finally never run. Restore the form and surface the error instead
          // of leaving the button stuck on 'Sending...'.
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-default-label') || 'Send Message';
          }
          if (summary && summaryList) {
            var contactSync = errorEmail
              ? ' Please try again or contact us at ' + errorEmail + '.'
              : ' Please try again.';
            summaryList.innerHTML = '<li>Something went wrong.' + contactSync + '</li>';
            summary.classList.add('is-visible');
            requestAnimationFrame(function () {
              var heading = summary.querySelector('p[tabindex]');
              if (heading) heading.focus();
            });
          }
        }
      });
    }

    var forms = document.querySelectorAll('form.basin-form');
    for (var i = 0; i < forms.length; i++) {
      initForm(forms[i]);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-addons"] && !Shopify.designMode) return;
  try {
    // Track addon selections (no form field injection)
  document.querySelectorAll('.custom-product-addon').forEach(function(addonEl) {
    var input = addonEl.querySelector('.custom-product-addon__input');
    if (!input) return;

    var img = addonEl.querySelector('.custom-product-addon__image img');
    if (img) { img._defaultSrc = img.src; }

    input.addEventListener('change', function() {
      var isCheckbox = this.type === 'checkbox';
      var variantId = isCheckbox ? this.dataset.variantId : this.value;
      var isActive = (isCheckbox && this.checked) || (!isCheckbox && variantId !== '');

      if (isActive) {
        addonEl.classList.add('selected');
      } else {
        addonEl.classList.remove('selected');
      }

      // Swap addon image to match selected variant
      if (img && !isCheckbox) {
        var selected = this.options[this.selectedIndex];
        var variantImg = selected ? selected.getAttribute('data-image') : null;
        if (variantImg) {
          img.src = variantImg;
          img.srcset = '';
        } else if (img._defaultSrc) {
          img.src = img._defaultSrc;
          img.srcset = '';
        }
      }
    });
  });

  // Intercept form submission to add addons via separate Cart API call
  function getSelectedAddons() {
    var addons = [];
    document.querySelectorAll('.custom-product-addon').forEach(function(addonEl) {
      var input = addonEl.querySelector('.custom-product-addon__input');
      if (!input) return;
      var isCheckbox = input.type === 'checkbox';
      var variantId = isCheckbox ? input.dataset.variantId : input.value;
      var isActive = (isCheckbox && input.checked) || (!isCheckbox && variantId !== '');
      if (isActive && variantId) {
        addons.push({ id: parseInt(variantId, 10), quantity: 1 });
      }
    });
    return addons;
  }

  // Listen for Horizon cart:update events to add addons after main product
  var addonsPending = false;
  document.addEventListener('cart:update', function(e) {
    if (addonsPending) return;
    var detail = e.detail || {};
    var data = detail.data || {};
    // Only act on successful product-form adds
    if (data.source !== 'product-form-component' || data.didError) return;

    var addons = getSelectedAddons();
    if (addons.length === 0) return;

    addonsPending = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: addons })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Refresh cart count by fetching updated cart
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Dispatch cart:update so Horizon refreshes the cart drawer/count
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { source: 'product-addons' } }
      }));
    })
    .finally(function() {
      addonsPending = false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-card-compare"] && !Shopify.designMode) return;
  try {
    if (!window.BACtrackProductCardCompare) {
    window.BACtrackProductCardCompare = true;

    function getProductList() {
      try {
        var parsed = JSON.parse(localStorage.getItem('compareList') || '[]');
        return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
      } catch (error) {
        return [];
      }
    }

    function setProductList(productList) {
      try {
        localStorage.setItem('compareList', JSON.stringify(productList));
      } catch (error) {
        return;
      }
    }

    function getCompareUrl() {
      var source = document.querySelector('.custom-product-card-compare[data-compare-url]');
      return source ? source.getAttribute('data-compare-url') : '/collections/breathalyzer-comparison';
    }

    function getCompareScheme() {
      var source = document.querySelector('.custom-product-card-compare[data-compare-scheme]');
      var scheme = source ? source.getAttribute('data-compare-scheme') : '';
      return scheme ? ' color-' + scheme : '';
    }

    function buildComparisonButton() {
      var wrapper = document.createElement('user-comparison-list');
      wrapper.className = 'custom-product-card-comparison-list is-floating';
      wrapper.setAttribute('data-product-card-comparison-list', '');
      wrapper.innerHTML =
        '<div class="custom-product-card-comparison-list__inner' + getCompareScheme() + '" data-comparison-button>' +
          '<a class="button button--small" data-comparison-link>Compare Breathalyzers</a>' +
          '<a class="custom-product-card-comparison-list__all" data-comparison-all-link>Compare All</a>' +
        '</div>';
      return wrapper;
    }

    function directChildButton(section) {
      for (var i = 0; i < section.children.length; i++) {
        if (section.children[i].hasAttribute &&
            section.children[i].hasAttribute('data-product-card-comparison-list')) {
          return section.children[i];
        }
      }
      return null;
    }

    // Render one sticky compare button per product section (each .shopify-section
    // that holds compare checkboxes), mirroring the live theme where the button
    // rides the bottom of the product grid and then scrolls away with the
    // section. Content pages and the comparison page itself have no product-card
    // checkboxes, so no button is created there.
    // Toggle "is-floating" while the sticky button is pinned to the viewport
    // (shadow shown). When it reaches its resting spot at the bottom of the
    // section it drops the shadow and sits inline. A 1px sentinel placed after
    // the button is observed: sentinel visible == resting, hidden == floating.
    function attachStickyState(button, section) {
      var sentinel = document.createElement('div');
      sentinel.className = 'custom-product-card-comparison-list__sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      section.appendChild(sentinel);
      if (!('IntersectionObserver' in window)) {
        button.classList.add('is-floating');
        return;
      }
      var observer = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          button.classList.toggle('is-floating', !entries[i].isIntersecting);
        }
      }, { threshold: 0 });
      observer.observe(sentinel);
    }

    function ensureComparisonButtons() {
      var inputs = document.querySelectorAll('.comparison-checkbox input[data-compare-id]');
      var sections = [];
      for (var i = 0; i < inputs.length; i++) {
        var section = inputs[i].closest('.shopify-section') || inputs[i].closest('.section');
        if (section && sections.indexOf(section) === -1) {
          sections.push(section);
        }
      }
      var buttons = [];
      for (var s = 0; s < sections.length; s++) {
        var button = directChildButton(sections[s]);
        if (!button) {
          button = buildComparisonButton();
          sections[s].appendChild(button);
          attachStickyState(button, sections[s]);
        }
        buttons.push(button);
      }
      return buttons;
    }

    function updateCompareLinks(wrapper) {
      var compareUrl = getCompareUrl();
      var selected = getProductList();
      var link = wrapper.querySelector('[data-comparison-link]');
      var allLink = wrapper.querySelector('[data-comparison-all-link]');

      if (link) {
        link.setAttribute('href', compareUrl);
        link.classList.toggle('disabled', selected.length <= 1);
        link.setAttribute('aria-disabled', selected.length <= 1 ? 'true' : 'false');
      }

      if (allLink) {
        allLink.setAttribute('href', compareUrl + '?pids=all');
      }
    }

    function updateComparisonUI() {
      var selected = getProductList();
      var inputs = document.querySelectorAll('.comparison-checkbox input[data-compare-id]');

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var checked = selected.indexOf(String(input.getAttribute('data-compare-id'))) !== -1;
        input.checked = checked;
        var label = input.closest('.custom-product-card-compare, .checkbox-label');
        if (label) label.classList.toggle('activated', checked);
      }

      var buttons = ensureComparisonButtons();
      for (var b = 0; b < buttons.length; b++) {
        updateCompareLinks(buttons[b]);
        buttons[b].hidden = selected.length === 0;
      }
    }

    document.addEventListener('change', function(event) {
      var input = event.target.closest('.comparison-checkbox input[data-compare-id]');
      if (!input) return;

      var id = input.getAttribute('data-compare-id');
      if (!id) return;

      var selected = getProductList();
      selected = selected.filter(function(value) {
        return value !== String(id);
      });

      if (input.checked) {
        selected.push(String(id));
      }

      setProductList(selected);
      updateComparisonUI();
    });

    document.addEventListener('keydown', function(event) {
      var input = event.target.closest('.comparison-checkbox input[data-compare-id]');
      if (!input) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      input.checked = !input.checked;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('click', function(event) {
      var link = event.target.closest('[data-comparison-link]');
      if (!link || link.getAttribute('aria-disabled') !== 'true') return;

      event.preventDefault();
    });

    document.addEventListener('DOMContentLoaded', updateComparisonUI);
    document.addEventListener('shopify:section:load', updateComparisonUI);

    window.addEventListener('storage', function(event) {
      if (event.key === 'compareList') {
        updateComparisonUI();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-metafield"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.custom-product-metafield--empty').forEach(function(el) {
    var row = el.closest('accordion-custom');
    if (row) {
      row.style.display = 'none';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
